<div class="edit-product">
    @if(mainPageIndex != 0){
        <div class="d-flex w-100 justify-content-start">
            <button class="t-btn" (click)="mainPageIndex = 0"
            ><i class="fas fa-arrow-left"></i> Back</button>
        </div>
      
    }
    @if(mainPageIndex == 0){
        <p class="title-txt mb-2"><i class="fas fa-hand-point-right"></i>  Take Control of your product</p>
        <button (click)="mainPageIndex = 1" class="btn btn-outline-secondary p-2">
           <i class="fas fa-coins"></i> Edit Prices
        </button> 
        <button  (click)="mainPageIndex = 2" class="btn btn-outline-secondary p-2">
            <i class="fa-solid fa-pen"></i> Edit Description
        </button> 
        <button  (click)="mainPageIndex = 3" class="btn btn-outline-secondary p-2">
            <i class="fa fa-star"></i>  Edit Promo
        </button> 
    } 
    @else if( mainPageIndex == 1){
        <p class="title-txt mb-2">Edit Price/Variants
           <button class="btn btn-sm btn-outline-secondary" (click)="addNewVariant()">+</button>
        </p>
        <div *ngFor="let variant of productVariants; index as i" class="d-flex w-100 align-items-center">
            @if(variant.convertedImage){
                <img [src]="variant.convertedImage" class="shadow upload-image" (click)="clickId(VARIANT_FILE_SELECTOR + i)">
            }
            @else if(variant.image){
                <img [src]="imgUrl + variant.image" class="shadow upload-image" (click)="clickId(VARIANT_FILE_SELECTOR + i)">
            }@else{
                <img src="../../assets/images/uploadd2.png" class="shadow upload-image"  (click)="clickId(VARIANT_FILE_SELECTOR + i)">
            }
            <input type="file" [id]="VARIANT_FILE_SELECTOR + i" class="d-none" (change)="imageChanged('variant', i, $event)"/>
            <div class="d-flex flex-column ml-4">
                <input type="text" placeholder="Name"  [(ngModel)]="variant.name"  class="form-control mb-2" />
                <input type="number" placeholder="Price" [(ngModel)]="variant.price"  class="form-control mb-2"/>
            </div>
            <button class="btn btn-sm btn-outline-primary ml-2" (click)="removeVariant(i)">-</button>
            

        </div>

    }   
    @else if( mainPageIndex == 2){
        <p class="title-txt mb-2">Change Description</p>
        <p class="mb-2" id="descrHolder"
          [class.line-break-5]="  !allowDescrHolderOverflow && doesDescrHolderOverflow"
        style="word-break: break-all;"
        >
          {{ descriptionNow }}
        </p>

        <div class="w-100 d-flex justify-content-center position-relative" style="color: var(--primary);">
          <button class="scroll-arrow" (click)="allowDescrHolderOverflow = !allowDescrHolderOverflow"
            *ngIf="doesDescrHolderOverflow">
            <span>See More</span>
            <i [class.down]="!allowDescrHolderOverflow" class="fa-solid fa-chevron-up"></i>
          </button>
        </div>

        <textarea [(ngModel)]="candidateDescription" placeholder="Input New Description" class="form-control"></textarea>
    }   
    @else if( mainPageIndex == 3){
        <p class="title-txt mb-2">Edit Promotions
            <button class="btn btn-sm btn-outline-secondary" (click)="addNewPromo()">+</button>
         </p>
         <div *ngFor="let promo of promos; index as i" class="d-flex w-100 align-items-center">
             @if(promo.convertedImage){
                 <img [src]="promo.convertedImage" class="shadow upload-image" (click)="clickId(PROMO_FILE_SELECTOR + i)">
             }
             @else if(promo.imageFile){
                 <img [src]="imgUrl + promo.imageFile" class="shadow upload-image" (click)="clickId(PROMO_FILE_SELECTOR + i)">
             }@else{
                 <img src="../../assets/images/uploadd2.png" class="shadow upload-image"  (click)="clickId(PROMO_FILE_SELECTOR + i)">
             }
             <input type="file" [id]="PROMO_FILE_SELECTOR + i" class="d-none" (change)="imageChanged('promo', i, $event)"/>
             <div class="d-flex flex-column ml-4">
                 <input type="text" placeholder="title"  [(ngModel)]="promo.serviceComment"  class="form-control mb-2" />
                 <textarea type="number" placeholder="Description" [(ngModel)]="promo.serviceDescription"  class="form-control mb-2"></textarea>
                 <div class="d-flex w-100 align-items-center" style="gap: .5em;">
                    <input (change)="promos[i].allowRefer = $event.target.checked"
                    [checked]="promos[i].allowRefer"
                     type="checkbox" style="accent-color: var(--secondary);" [id]="'promoCheck' + i"/>
                    <label [for]="'promoCheck' + i" style="line-height: unset !important; margin-bottom: 0 !important;">Can Be Refered</label>
                 </div>
                 <input *ngIf="promos[i].allowRefer"
                            (change)="promos[i].referAmount = $event.target.value"
                            [value]="promos[i].referAmount" type="number" placeholder="$"
                            class="my-2 form-control" />
                
                <label for="select-expiry" style="color: var(--primary); margin-bottom: 0">Select Expiry:</label>
                <select (change)="expiryStringChanged($event, i)" class="select-expiry ml-2">
                    <option *ngFor="let val of availableExpiryIntervals" class="p-2" [value]="val"
                        [selected]="val == promos[i]?.expiryInString">
                        <!-- <input [id] = "'rd' + val" type="radio"   (change)="expiryStringChanged($event)" [(ngModel)]="editproexpiryInString'" class="mr-2" />
                        <label [for]="'rd' + val">{{val}} </label> -->
                        {{val}}
                    </option>
                    </select>
             </div>
             <button class="btn btn-sm btn-outline-primary ml-2" (click)="removePromo(i)">-</button>
             
 
         </div>
        
    }   

    @if(mainPageIndex != 0){
        <div class="d-flex w-100 justify-content-center">
            <button class="t-btn" (click)="submitChanges()"
            ><i class="fa fa-check"></i> Save</button>
        </div>
      
    }

</div>